import { itiHttpService, itiMessageService } from '@/iti-core-vue';
import { ItiIconButton, ItiVHeader, ItiList } from '@/iti-core-vuetify';
import collaborativeAreaModule from '@/store/modules/collaborative-area.module';
import { Component, Prop, Vue } from "vue-property-decorator";
import NextEvents from '@/components/next_events/next_events.vue';
import LastFiles from '@/components/last_files/last_files.vue';
import LastMessages from '@/components/last_messages/last_messages.vue';
import UsersByCollaborativeArea from '@/components/users_by_collaborative_area/users_by_collaborative_area.vue'
import ForumResume from '@/components/forum-resume/forum-resume.vue';
import DxButton from 'devextreme-vue/button';
import { userModule } from '@/store/modules';

@Component({
  components: { 
    ItiIconButton,                       
    NextEvents,
    LastFiles,
    LastMessages,

    UsersByCollaborativeArea,
	ForumResume,
    DxButton
  }
})
export default class CollaborativeAreaDetails extends Vue { 

  @Prop() public id !: number;    

  public get collaborativeArea() {
    return collaborativeAreaModule.selectedCollaborativeArea;
  }

  public get userRoleInArea() {
    return userModule.userRoleInArea;
  }
  
  public get isOwnerRole() {    
    return this.userRoleInArea.roleId == 4;
  }

  public mounted() {
    if (!isNaN(this.id) && this.id != 0) {
      collaborativeAreaModule.getCollaborativeAreaById(this.id).catch( () => {itiMessageService.toast(this.$tc('mensajes-plantillas.info-error'), 'error', 2000);});
      userModule.getUserRoleInArea(this.id);
      collaborativeAreaModule.fetchId();
    }
  } 
  
  public editCollaborativeArea() {    
    this.$router.push({ name: 'CollaborativeAreaForm', params: { id: this.collaborativeArea.id.toString() } });
  }

  public disassociateUserToArea() {    
    itiMessageService.confirm(this.$tc('collaborative-area.pregunta-abandonar-usuario-area'), this.$tc('mensajes.confirmar'), (res) => {        
      if (res) { 
        collaborativeAreaModule.collaborativeAreaMember.ambitId = this.id;
        collaborativeAreaModule.collaborativeAreaMember.userId = collaborativeAreaModule.myId;
        collaborativeAreaModule.disassociateUserToCollaborativeArea()             
        .then( () => {          
          itiMessageService.toast(this.$tc('collaborative-area.abandonedArea'), 'success', 3000);
          switch(this.collaborativeArea.type) {
            case 0: this.$router.push({ name: 'areasPublicas' }); break;
            case 1: this.$router.push({ name: 'gruposTrabajo' }); break;
            case 2: this.$router.push({ name: 'areasColaborativas' }); break;
          }
        })
        .catch( () => {                    
          itiMessageService.toast(this.$tc('mensajes-plantillas.info-error'), 'error', 2000);
        });                         
      }
    });
  }

  public backToHome() {
    switch(this.collaborativeArea.type) {
      case 0: this.$router.push({ name: 'areasPublicas' }); break;
      case 1: this.$router.push({ name: 'gruposTrabajo' }); break;
      case 2: this.$router.push({ name: 'areasColaborativas' }); break;
    }
  }
  
}